/**
 * Data Source: Fetch Dashboard
 * Handles data fetching and transformation for dashboard
 */

import type { FetchDashboardModel } from '../../../domain/model/DashboardModel';
import type { FetchDashboardResponse } from '../response';
import type { DashboardApiService } from '../service/DashboardAPIService';

export async function FetchDashboardDataSource(
  service: DashboardApiService,
): Promise<FetchDashboardModel> {
  const response = await service.fetchDashboard();
  return convertResponseToModel(response);
}

function convertResponseToModel(
  response: FetchDashboardResponse,
): FetchDashboardModel {
  return {
    widgets: response.widgets.map((widget) => ({
      ...widget,
      lastUpdated: widget.lastUpdated ? new Date(widget.lastUpdated) : undefined,
    })),
    user: response.user,
    navigationItems: response.navigationItems,
    summary: response.summary,
    userTiers: response.userTiers,
    transactionActivity: response.transactionActivity,
    merchantPoints: response.merchantPoints,
    cityTransactions: response.cityTransactions,
    genderDemographics: response.genderDemographics,
    ageDemographics: response.ageDemographics,
    reportDetail: response.reportDetail,
  };
}

